/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Plan_Change_SubmitInputs */

const fr_membership_plan_change_submit = /** @type {(inputs: Membership_Plan_Change_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmer le changement`)
};

/**

* @param {Membership_Plan_Change_SubmitInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_plan_change_submit = /** @type {((inputs?: Membership_Plan_Change_SubmitInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Plan_Change_SubmitInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_plan_change_submit(inputs)
});